import React from "react";
import {
  defineBlock,
  smartProps,
  EditableImg,
  useToolbar,
  useEditor,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import {
  PanelBody,
  PanelRow,
  TextControl,
  ToolbarButton,
} from "@wordpress/components";
import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import EditableText from "../shared/editable-text";
import style from "./block.module.scss";
const ALLOWED_MEDIA_TYPES = ["image"];

function Inspector() {
  const [url, setUrl] = useSmartProp("url");
  const [urlText, setUrlText] = useSmartProp("urlText");
  return (
    <>
      <PanelBody title="Configuration Lien" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Lien"}
            value={url}
            onChange={(value) => setUrl(value)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Texte du lien"}
            value={urlText}
            onChange={(value) => setUrlText(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ url, urlText, background }) {
  useInspectorControl(Inspector);
  const { updateData } = useEditor();
  useToolbar(() => {
    return (
      <MediaUploadCheck>
        <MediaUpload
          onSelect={(image) => updateData({ background: image })}
          allowedTypes={ALLOWED_MEDIA_TYPES}
          value={background ? background.id : null}
          render={({ open }) => (
            <ToolbarButton
              onClick={open}
              icon="camera"
              label="Modifier l'image"
            />
          )}
        />
      </MediaUploadCheck>
    );
  }, [background, updateData]);
  return (
    <div
      className={style.block}
      style={{
        backgroundImage: background ? `url(${background.url})` : undefined,
      }}
    >
      <div className={style.content}>
        <EditableText className={style.title} tagName="h2" smartProp="title" />
        <div className={style.bar} />
        <div className={style.img}>
          <EditableImg smartProp="logo" />
        </div>
        <EditableText className={style.text} smartProp="text" />
        {url && (
          <div className={style.bouton}>
            <a href={url}>
              <span>{urlText}</span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    url: smartProps.string.withDefault(""),
    urlText: smartProps.string.withDefault(""),
    logo: smartProps.any.withDefault(),
    background: smartProps.any.withDefault(),
  },
  setup: {
    title: "Penser à demain",
  },
});
